module.exports = "<five-roll-game style=\"height:100%;overflow: hidden;\">\n</five-roll-game>\n<style type=\"text/css\">{{style.content}}</style>\n"


//////////////////
// WEBPACK FOOTER
// ./src/templates/main/index.hbs
// module id = 213
// module chunks = 0